import FirmDetails from '../src/FirmDetails';
export default FirmDetails;
